module.exports = __webpack_public_path__ + "img/works-detail_6.12e2d99b.png";